module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/CentralJuvie-5_BW-p-2000-5a5406bcaf1ec67da4a91305247170ee.jpg";